export enum CustomerProfile{
    Marine = 'MARINE',
    Workshop = 'WORKSHOP',
    MarineAndWorkshop = 'WORKSHOP_AND_MARINE'
}
